import moment from "moment-timezone";

import * as pdfApi from "@/apiv2/pdfCustomisation";
import { handleError } from "@/redux/utils/error";
import { STATUS } from "@/utils/constants";
import * as date from "@/utils/date";

import { dependencies } from "../../../../package.json";

import { RESET, SET_IS_CREATING_TEMPLATE_STATUS } from "./select-template.actionTypes";

export const reset = () => (dispatch) => {
  dispatch({
    type: RESET,
  });
};

export const setIsCreatingTemplateStatus = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_CREATING_TEMPLATE_STATUS,
    payload: status,
  });
};

export const createTemplate = (template) => async (dispatch) => {
  try {
    dispatch(setIsCreatingTemplateStatus(STATUS.PENDING));

    // Response is not converted to camelCase
    // to Prevent keys from the pdf editor data to formatted
    const { data } = await pdfApi.getGlobalTemplate(template.uid)();

    const formData = new FormData();
    formData.append("global_template", data.uid);
    formData.append("content", JSON.stringify(data.content));
    formData.append("is_default", false);
    formData.append("name", data.name);
    formData.append("description", "");
    formData.append("version", dependencies["@factory/pdf-customisation"]);

    const blob = new Blob([data.html_content], { type: "text/html" });
    const htmlFile = new File(
      [blob],
      `${template.key}-${date.toLocalDateTime({
        date: moment.tz(date.getCurrentUserTimezone()),
        timezone: date.getCurrentUserTimezone(),
        format: "YYYY-MM-DDTHHmmssZ",
      })}.html`,
      { type: "text/html" }
    );
    formData.append("html_file", htmlFile);

    const { data: newTemplate } = await pdfApi.postCompanyTemplate(formData)();

    dispatch(setIsCreatingTemplateStatus(STATUS.FULFILLED));

    return newTemplate;
  } catch (error) {
    dispatch(setIsCreatingTemplateStatus(STATUS.REJECTED));
    handleError(error, dispatch);
  }
};
